import { render, staticRenderFns } from "./LoginDorm.vue?vue&type=template&id=3e08cbed&"
import script from "./LoginDorm.vue?vue&type=script&lang=js&"
export * from "./LoginDorm.vue?vue&type=script&lang=js&"
import style0 from "./LoginDorm.vue?vue&type=style&index=0&id=3e08cbed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports